import { useContext } from "react";
import StarRating from "../Components/StarRating";
import StarRatingMobileView from "../Components/StarRatingMobileView";
import { StarRatingPropsTypes } from "../StarRatingPropsTypes";
import { CheckResponsiveContext } from "../../../Context/CheckResponsiveContext";

function StarRatingContainer({
  surveyAnswers,
  setSurveyAnswers,
  isPreview,
  questionObjVariable,
  questionId,
  surveyAnswersInfo,
}: StarRatingPropsTypes) {
  const { isMobile } = useContext(CheckResponsiveContext);
  //starRating
  const handleChangeInputStarRating: StarRatingPropsTypes["handleChangeInputStarRating"] =
    (ratingCount, questionId, optionId, name, weightage) => {
      setSurveyAnswers((draft: StarRatingPropsTypes["surveyAnswers"]) => {
        draft[questionId] = draft[questionId] || {};
        draft[questionId]["val"] = name;
        draft[questionId]["optionId"] = optionId;
        if (surveyAnswersInfo.surveyInfo.isScoreEnable) {
          draft[questionId]["score"] = weightage;
        }
        draft[questionId]["rating"] = ratingCount;
      });
    };
  return (
    <>
      {isMobile ? (
        <StarRatingMobileView
          handleChangeInputStarRating={handleChangeInputStarRating}
          surveyAnswers={surveyAnswers}
          isPreview={isPreview}
          questionObjVariable={questionObjVariable}
          questionId={questionId}
          surveyAnswersInfo={surveyAnswersInfo}
        />
      ) : (
        <StarRating
          handleChangeInputStarRating={handleChangeInputStarRating}
          surveyAnswers={surveyAnswers}
          isPreview={isPreview}
          questionObjVariable={questionObjVariable}
          questionId={questionId}
          surveyAnswersInfo={surveyAnswersInfo}
        />
      )}
    </>
  );
}

export default StarRatingContainer;
